import axios, { parseAxiosError } from '@/portainer/services/axios/axios';
import { EdgeGroup } from '@/react/edge/edge-groups/types';

import { EdgeStack, HelmConfig, StaggerConfig } from '../../types';
import { buildUrl } from '../buildUrl';

export type HelmRepositoryPayload = {
  /** Name of the stack */
  name: string;
  /** List of identifiers of EdgeGroups */
  edgeGroups: Array<EdgeGroup['Id']>;
  /** Helm configuration (ChartURL and ChartName are required) */
  helmConfig: HelmConfig;
  /** Configuration for stagger updates */
  staggerConfig?: StaggerConfig;
};

export async function createStackFromHelmRepository(
  payload: HelmRepositoryPayload
) {
  try {
    const { data } = await axios.post<EdgeStack>(
      buildUrl(undefined, 'create/helmRepo'),
      payload
    );
    return data;
  } catch (e) {
    throw parseAxiosError(e as Error);
  }
}
